import { RootDynamicComponentHelper } from '@shared/helpers/root-dynamic-component-helper';
import {FootnoteDialogComponent} from './components/dialog-components/footnote-dialog/footnote-dialog/footnote-dialog.component';
import {ProgressiveBlockDialogComponent} from './components/dialog-components/progressive-block-dialog/progressive-block-dialog/progressive-block-dialog.component';
import {PlatformToolTreatyCountryPairSelectorComponent} from '@features/treaty/components/platform-tool-treaty-country-pair-selector/platform-tool-treaty-country-pair-selector.component';
import {PlatformToolTreatyDocumentWrapperContentComponent} from '@features/treaty/components/platform-tool-treaty-document-wrapper-content/platform-tool-treaty-document-wrapper-content.component';
import {TreatyCountryPairSelectorDialogComponent} from '@features/treaty/components/treaty-country-pair-selector-dialog/treaty-country-pair-selector-dialog.component';
import {PlatformToolCountryPairSelectorButtonComponent} from '@features/treaty/components/platform-tool-country-pair-selector-button/platform-tool-country-pair-selector-button.component';
import {PlatformToolTreatyOtherDocumentWrapperContentComponent} from '@features/treaty/components/platform-tool-treaty-other-document-wrapper-content/platform-tool-treaty-other-document-wrapper-content.component';
import {PlatformToolTreatyOtherVersionButtonComponent} from '@features/treaty/components/platform-tool-treaty-other-version-button/platform-tool-treaty-other-version-button.component';
import {PlatformToolTreatyOtherVersionPopupComponent} from '@features/treaty/components/platform-tool-treaty-other-version-popup/platform-tool-treaty-other-version-popup.component';
// @dynamic
export class TreatyDynamicComponentHelper {
  static components: any;

  static create (): void {
  }

  public static init () {
    if (TreatyDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    components['FootnoteDialogComponent'] = FootnoteDialogComponent;
    components['ProgressiveBlockDialogComponent'] = ProgressiveBlockDialogComponent;
    components['PlatformToolTreatyCountryPairSelectorComponent'] = PlatformToolTreatyCountryPairSelectorComponent;
    components['PlatformToolTreatyDocumentWrapperContentComponent'] = PlatformToolTreatyDocumentWrapperContentComponent;
    components['TreatyCountryPairSelectorDialogComponent'] = TreatyCountryPairSelectorDialogComponent;
    components['PlatformToolCountryPairSelectorButtonComponent'] = PlatformToolCountryPairSelectorButtonComponent;
    components['PlatformToolTreatyOtherDocumentWrapperContentComponent'] = PlatformToolTreatyOtherDocumentWrapperContentComponent;
    components['PlatformToolTreatyOtherVersionButtonComponent'] = PlatformToolTreatyOtherVersionButtonComponent;
    components['PlatformToolTreatyOtherVersionPopupComponent'] = PlatformToolTreatyOtherVersionPopupComponent;
    TreatyDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }

  public static getComponentArray (): any[] {
    TreatyDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(TreatyDynamicComponentHelper.components).forEach(key => {
      componentArray.push(TreatyDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
  public static register(key: string, component: any) {
    TreatyDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
}
